/**
 * @class AbstractAuthProvider
 * @template U, T, C, A
 */
export class AbstractAuthProvider {

    /**
     * @param {T} identifier
     * @returns {Promise<U>}
     * @abstract
     */
    user(identifier) {

        throw new Error("Abstract method should be implemented in derived class");
    }

    /**
     * @param {C} credentials
     * @returns {Promise<A>}
     * @abstract
     */
    request(credentials) {

        throw new Error("Abstract method should be implemented in derived class");
    }

    /**
     *
     * @param {T} identifier
     * @returns {Promise<boolean>}
     * @abstract
     */
    revoke(identifier) {

        throw new Error("Abstract method should be implemented in derived class");
    }
    
    /**
     * @param {string} refreshToken
     * @returns {Promise<{identifier: T}>}
     * @abstract
     */
    refreshToken(refreshToken) {
        
        throw new Error("Abstract method should be implemented in derived class");
    }
}


// WEBPACK FOOTER //
// ./src/auth/services/abstractAuthProvider.service.js